import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import Button from 'tio-ui/components/button';
import { or } from 'tio-ui/utilities';
import { PhChartLine, PhTable } from 'ember-phosphor-icons';

export type ViewType = 'table' | 'chart';

interface ViewToggleSignature {
  Args: {
    currentView: ViewType;
    onViewChange: (view: ViewType) => void;
    disabled?: boolean;
    chartDisabled?: boolean;
    tableDisabled?: boolean;
  };
}

export default class ViewToggle extends Component<ViewToggleSignature> {
  get isTableActive() {
    return this.args.currentView === 'table';
  }

  get isChartActive() {
    return this.args.currentView === 'chart';
  }

  switchToTable = () => {
    if (!this.args.tableDisabled) {
      this.args.onViewChange('table');
    }
  };

  switchToChart = () => {
    if (!this.args.chartDisabled) {
      this.args.onViewChange('chart');
    }
  };

  <template>
    <div
      class="flex gap-0.5 tio-surface-sunken border tio-border-subtle shrink-0"
      data-test-view-toggle
    >
      <Button
        @appearance={{if this.isTableActive "default" "minimal"}}
        @intent={{if this.isTableActive "primary" "default"}}
        @size="sm"
        @isDisabled={{or @disabled @tableDisabled}}
        {{on "click" this.switchToTable}}
        @icon={{PhTable}}
        @label="Table"
        data-test-table-button
      />

      <Button
        @appearance={{if this.isChartActive "default" "minimal"}}
        @intent={{if this.isChartActive "primary" "default"}}
        @size="sm"
        @isDisabled={{or @disabled @chartDisabled}}
        {{on "click" this.switchToChart}}
        @icon={{PhChartLine}}
        @label="Chart"
        data-test-chart-button
      />
    </div>
  </template>
}
